module.exports = __webpack_public_path__ + "static/media/qualification-1.8642c33c.svg";